import { InputBase, InputCollectiveBargainAgreementController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

import { Objects } from "@salaxy/core";

/**
 * Visual selection for collective bargain agreement codes.
 * @example
 * ```html
 * <salaxy-input-collective-bargain-agreement ng-model="row.code"></salaxy-input-collective-bargain-agreement>
 * ```
 */
export class InputCollectiveBargainAgreement extends ComponentBase {

    /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
    public require = {
      model: "ngModel",

      form: "?^^form",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = Objects.extend(InputBase.crudBindings, {
        /** List of collective bargain agreement codes to exclude from the selection list. */
        hiddenCodes: "<",
    });

    /** Uses the InputCollectiveBargainAgreementController */
    public controller = InputCollectiveBargainAgreementController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/InputCollectiveBargainAgreement.html";
}
